import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    GET_APPLIED_FILTERS_SUCCESS,
    GET_APPLIED_FILTERS_FAILURE,
} from '../actions';
import { convertObjectToQueryParams } from 'src/utils/util';

export default function* getAppliedFilters(action) {
    const params = convertObjectToQueryParams({ ...action.payload });
    // cache-bust: Safari can serve a stale disk-cached response for this URL otherwise
    const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/orders/filter?${params}&_=${Date.now()}`;
    try {
        const result = yield axios.get(url).then((response) => response.data);

        yield put({ type: GET_APPLIED_FILTERS_SUCCESS, data: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload,
        });
        yield put({
            type: GET_APPLIED_FILTERS_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
